import {Chart} from 'react-google-charts'
import NoData from './NoData'

class TopItemsByCategoryAllChart extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      charts: []
    }
  }

  render () {
    const topItemsByCategory = this._topItemsByCategory()
    const {ChartLoadingSpinner} = this.props
    return (
      <div>
        {topItemsByCategory.charts.length > 0 && topItemsByCategory.charts.map((chart, idx) => {
          let chartOptions = {
            title: chart.name,
            legend: { position: 'none' },
            vAxis: { gridlines: { colors: 'transparent' } },
            colors: ['#3498DB', '#3498DB']
          }

          return <div key={idx} className='col-md-3' >
            <div className='categories-sales-by-volume'>
              <Chart
                chartType='ColumnChart'
                data={chart.rows}
                options={chartOptions}
                graph_id={`top-items-by-category-${idx}-chart`}
                width='100%'
                height='200px'
                legend_toggle
                loader={<ChartLoadingSpinner />}
                />
            </div>
          </div>
        })}
        {!topItemsByCategory.charts.length && <NoData />}
      </div>)
  }

  _topItemsByCategory = () => {
    let charts = []
    let data = {}
    this.props.transactions.forEach((t) => {
      t.payments.forEach(p => {
        p.checkouts.forEach(c => {
          let categoryName = c.category_name
          let itemName = c.item_name

          if (itemName && !p.is_refunded) {
            if (!data.hasOwnProperty(categoryName)) {
              data[categoryName] = { name: categoryName, items: {} }
              charts.push(data[categoryName])
            }

            if (!data[categoryName].items.hasOwnProperty(itemName)) {
              data[categoryName].items[itemName] = { name: itemName, count: 0, gross_sales: 0 }
            }
            data[categoryName].items[itemName].count += c.quantity
            data[categoryName].items[itemName].gross_sales += c.gross_sales
          }
        })
      })
    })
    // convert all of this into array
    let retState = []
    for (let categoryName in data) {
      let categoryItems = {name: categoryName}
      categoryItems.items = []
      let items = data[categoryName].items
      for (let itemName in items) {
        categoryItems.items.push({
          name: data[categoryName].items[itemName].name,
          count: data[categoryName].items[itemName].count,
          gross_sales: data[categoryName].items[itemName].gross_sales
        })
      }
      retState.push(categoryItems)
    }
    let stateCharts = []
    retState.forEach((chart) => {
      let chartRows = []
      // header
      chartRows.push([{role: 'domain'}, 'Count'])
      chart.items.sort(this._cmpItemDesc)

      for (let i = 0; i < Math.min(3, chart.items.length); i++) {
        const item = chart.items[i]
        chartRows.push([item.name, item.count])
      }
      stateCharts.push({name: chart.name, rows: chartRows})
    })
    return {charts: stateCharts}
  }

  /**
   *
   * @param {{name,count, gross_sales}} itemA
   * @param {{name,count, gross_sales}} itemB
   * @private
   */
  _cmpItemDesc (itemA, itemB) {
    if (itemA.count !== itemB.count) {
      if (itemA.count > itemB.count) {
        return -1
      } else {
        return 1
      }
    } else if (itemA.gross_sales !== itemB.gross_sales) {
      if (itemA.gross_sales > itemB.gross_sales) {
        return -1
      } else {
        return 1
      }
    } else {
      return 0
    }
  }
}

TopItemsByCategoryAllChart.propTypes = {
  transactions: React.PropTypes.array,
  ChartLoadingSpinner: React.PropTypes.node
}
export default TopItemsByCategoryAllChart



// WEBPACK FOOTER //
// ./app/pages/Dashboard/TopItemsByCategoryAllChart.js